<template>
  <div v-if="lastOrder.order">
    <h1 class="mb-6">Vielen Dank für Deine Bestellung ❤️</h1>
    <p v-if="!isOfficeOrderClient">
      <a v-if="lastOrder.order.homedelivery == 'N' && !lastOrder.order.tableId" :href="gmapsUrl" target="_blank">
        <img class="map" :src="mapUrl" alt="Lieferroute" />
      </a>
      <img v-if="lastOrder.order.homedelivery == 'Y'" class="map" :src="mapUrl" alt="Lieferroute" />

      <span v-if="lastOrder.order.payment == 'nachnahme' && lastOrder.order.homedelivery == 'Y'">Bitte halte den Betrag von <nobr>{{ (lastOrder.order.sum + lastOrder.order.shipping) | pricetag }}</nobr> bereit.<br /></span>
      <span v-if="lastOrder.order.payment == 'nachnahme' && lastOrder.order.homedelivery == 'N' && !lastOrder.order.tableId">Bitte halte bei der Abholung den Betrag von <nobr>{{ (lastOrder.order.sum + lastOrder.order.shipping) | pricetag }}</nobr> bereit.<br /></span>

      <span v-if="lastOrder.order.homedelivery == 'N' && lastOrder.host.hostId != 268 && !lastOrder.order.tableId">
        <br />
        Hier bist du richtig um deine Bestellung abzuholen:<br />
        <strong>{{ lastOrder.host.name }}</strong><br />
        {{ lastOrder.host.street }} {{ lastOrder.host.number }}<br />
        {{ lastOrder.host.zip }} {{ lastOrder.host.city }}<br />
        <a :href="gmapsUrl" target="_blank" class="text-green-heinz">Ziel in Google Maps öffnen</a><br />
        <br />
      </span>
      Deine Bestellnummer ist die {{ lastOrder.order.orderId }}<br />

      <template v-if="!lastOrder.order.tableId">
        <span v-if="estimated && lastOrder.order.deliverytime == '0000-00-00 00:00:00'">Die geschätze <span v-if="lastOrder.order.homedelivery == 'Y'">Lieferzeit</span><span v-if="lastOrder.order.homedelivery == 'N'">Zubereitungszeit</span> beträgt {{ estimated }} Minuten.<br /></span>
        Über den weiteren Verlauf deiner Bestellung wirst du in Kürze per WhatsApp oder SMS informiert.<br />
        Bei Rückfragen zu deiner Bestellung erreichst du {{ lastOrder.host.name }} unter der <strong>{{ lastOrder.host.phone }}</strong><br />
      </template>
    </p>
    <p>Guten Appetit!</p>

    <orderstatus class="mt-8" />
    <orderdetails :order="lastOrder" class="pt-8"></orderdetails>

    <button v-if="isPosApp" @click="resetPosAppOrder()" class="mx-auto block my-12 bg-green-heinz hover:bg-green-heinz-light text-sm text-black py-4 px-8 rounded text-3xl">Neue Bestellung starten</button>
    <quickregistration v-if="isFoodi && !isPosApp && !lastOrder.order.tableId" />
    <feedback />

    <section class="pt-8" v-if="instagram && !isPosApp">
      <h2>Teile deinen Genuss!</h2>
      <div class="sm:flex">
        <div class="sm:w-12">
          <a :href="instagram" class="block w-full max-w-xs mx-auto text-center" target="_blank">
            <img src="/static/Instagram_logo_2016.svg" class="w-full" alt="Instagram" />
          </a>
        </div>
        <div class="pt-4 sm:pt-0 sm:pl-3">
          Teile ein Foto von deinem Essen auf Instagram und markiere <a :href="instagram" class="text-green-heinz-darkest" target="_blank">@{{ instagramName }}</a> - wir teilen es anschließend in einer Story 😎<br />
          <template v-if="facebook">Du findest uns natürlich auch auf <a :href="facebook" class="text-green-heinz-darkest" target="_blank">{{ facebook }}</a></template>
        </div>
      </div>
    </section>

    <section class="pt-8" v-if="!isPosApp && !isStrandbutler && !lastOrder.order.tableId">
      <h2>Es fehlt noch jemand?</h2>
      <recommend class="mt-4" mode="recommend" hideHeadline="true"></recommend>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import endpoints from '../../endpoints'
import { mapGetters } from 'vuex'
import Feedback from '../../components/Feedback.vue'
import Recommend from '../recommend/index.vue'
import OrderStatus from '../../components/OrderStatus.vue'
import OrderDetails from '../../components/OrderDetails.vue'
import Quickregistration from '../../components/Quickregistration.vue'

export default {
  name: 'Danke',

  data () {
    return {
      hostId: window.hostId,
      lastOrder: {},
      lastHost: {},
      estimated: null
    }
  },

  components: {
    'feedback': Feedback,
    'recommend': Recommend,
    'orderstatus': OrderStatus,
    'orderdetails': OrderDetails,
    'quickregistration': Quickregistration
  },

  computed: {
    ...mapGetters([
      'isOfficeOrderClient'
    ]),

    isFoodi () {
      return window.type === 'foodi'
    },

    mapUrl () {
      return endpoints.baseUrl + '/api/map/' + this.lastOrder.order.orderId
    },

    gmapsUrl () {
      return 'https://www.google.com/maps/dir//' + this.lastOrder.host.street + '+' + this.lastOrder.host.number + ',+' + this.lastOrder.host.zip + '+' + this.lastOrder.host.city + '/'
    }
  },

  created () {
    window.parent.postMessage('orderCompleted', '*')
    this.handlePosAppOrder()

    axios.post(endpoints.lastOrder, {
      'hostId': this.hostId
    })
      .then(response => {
        this.lastOrder = response.data
      })
      .catch(e => {
        console.log(e)
      })
  },

  methods: {
    handlePosAppOrder () {
      if (!this.isPosApp) return

      window.setTimeout(() => {
        this.resetPosAppOrder()
      }, 60000)
    },

    resetPosAppOrder () {
      this.$router.push({ name: 'Shop', params: { hostUrl: window.hostUrl } })
    }
  }
}
</script>

<style lang="scss">
  .map {
    @apply block;
    @apply mb-4;
    @apply -mx-4;
    @apply w-screen;

    max-width: 100vw;
    max-height: 220px;
    height: auto;

    @screen md {
      @apply mx-0;
      max-width: 100%;
      max-height: 440px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/confirmation/done.vue